import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deletePurchaseOrder } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeletePurchaseOrderButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = async () => {
    const { purchaseOrderId, dispatchDeletePurchaseOrder } = this.props;
    dispatchDeletePurchaseOrder({ purchaseOrderId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeletePurchaseOrderButton.propTypes = {
  purchaseOrderId: PropTypes.number.isRequired,
  dispatchDeletePurchaseOrder: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeletePurchaseOrder: deletePurchaseOrder,
};

export default connect(null, mapDispatchToProps)(DeletePurchaseOrderButton);
